import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { User } from '../models/user.models';
import { StorageService } from 'src/app/shared/services/storage.service';

@Injectable()
export class LoginService {
  currentUser: User;
  serverUrl = environment.serverUrl;
  role: string;

  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar,
    private storage: StorageService
  ) {
    if (this.storage.getItem('name') && this.storage.getItem('token')) {
      this.currentUser = new User(this.storage.getItem('name'), this.storage.getItem('token'), this.storage.getItem('user_group'));
    }
  }

  login(data) {
    return new Promise<any>((resolve, reject) => {
      this.httpClient.post(this.serverUrl + '/user/obtain_token/', data)
        .subscribe(
          (response: User) => {
            this.storage.setItem('token', response.token);
            this.currentUser = new User(response.name, response.token, response.user_group);
            this.storage.setItem('name', response.name);
            this.storage.setItem('avatar', response.profile_pic);
            this.storage.setItem('user_group', response.user_group);
            this.storage.setItem('userEmail', data.email);
            sessionStorage.setItem('logined', 'true');
            resolve(data);
            this.router.navigate(['']);
          },
          (error) => {
            this.snackBar.open(error.error.error, 'close', {
              duration: 4000
            });
          }
        );
    });
  }

  getRole(){
    this.role = localStorage.getItem('user_group');
    return this.role;
  }

  logout() {
    return new Promise<any>((resolve, reject) => {
      const email = this.storage.getItem('userEmail');
      if (email) {
        this.httpClient.post(this.serverUrl + '/user/logout/', { email }, {})
          .subscribe((msg) => {
              resolve(msg);
              this.router.navigate(['login']);
            },
            error => {
              this.router.navigate(['login']);
            }
          );
        this.storage.clear();
      }
    });
  }

  resetPassword(email: object) {
    return this.httpClient.post(this.serverUrl + '/user/forgot_password/', email);
  }

  setNewPassword(id: number, token: string, newPassword: string) {
    return this.httpClient.post(this.serverUrl + '/user/reset_password/', { id, token, new_password: newPassword });
  }
}
